import axios from 'axios';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import './index.css';

//axios.defaults.baseURL = 'http://localhost:4000';
//axios.defaults.baseURL = 'http://85.31.235.16:4000';

axios.defaults.baseURL = 'https://mrgestor.com/';


//axios.defaults.baseURL = '/';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);